export default __webpack_public_path__ + "static/media/03_gallery.d01a9faa.jpg";